import { SERVICES } from "./serviceConstants";

export const SERVICE_CONTEXT_CONFIG = {
  [SERVICES.MY_FPO]: {
    route: "/myFpo",
    apiModule: "MyFPO",
    labels: {
      homeTitle: "Org",
      companyName: "Org",
      registrationTitle: "FPO/FPC Registration",
      memberLabel: "Member",
      dashboardTitle: "Org Dashboard",
    },
  },
  [SERVICES.MY_BUSINESS]: {
    route: "/mybusiness",
    apiModule: "MyBusiness",
    labels: {
      homeTitle: "Business",
      companyName: "Company",
      registrationTitle: "Company Registration",
      memberLabel: "Member",
      dashboardTitle: "Business Dashboard",
    },
  },
};
